<template>
  <View direction="column" gap="xs" class="list">
    <ChecklistRow
      v-for="portfolio in portfolios"
      :id="`portfolio-choice-${portfolio.id}`"
      :key="portfolio.id"
      :title="portfolio.name"
      :subtitle="lockedReasons?.[portfolio.id] ?? describe(portfolio)"
      :checked="selected.includes(portfolio.id) || Boolean(lockedReasons?.[portfolio.id])"
      :disabled="Boolean(lockedReasons?.[portfolio.id])"
      @toggle="toggle(portfolio.id, $event)"
    />
  </View>
</template>

<script setup lang="ts">
import pluralize from 'pluralize';

import { ChecklistRow, View } from '@tallo/design-system';
import { PortfolioDto, teamMemberName, useCompanyTeamQuery } from '@tallo/investor/company';

/** Portfolios to join as a collaborator. A locked one is shown ticked and greyed, with why in place of its details. */
defineProps<{ portfolios: PortfolioDto[]; lockedReasons?: Record<string, string> }>();
const selected = defineModel<string[]>({ required: true });

const { members } = useCompanyTeamQuery();

function describe(portfolio: PortfolioDto): string {
  const owner = members.value.find((member) => member.investorId === portfolio.ownerId);
  const units = pluralize('property', portfolio.unitCount, true);

  return owner ? `${units} · owned by ${teamMemberName(owner)}` : units;
}

function toggle(portfolioId: string, checked: boolean) {
  selected.value = checked
    ? [...selected.value, portfolioId]
    : selected.value.filter((selectedId) => selectedId !== portfolioId);
}
</script>

<style scoped lang="scss">
// A company with many portfolios scrolls inside the dialog instead of pushing its buttons off screen
.list {
  max-height: 16rem;
  overflow-y: auto;
}
</style>
